import { generatePath } from 'react-router-dom'
import { APPROVALS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Workspace } from 'types'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Approvals } from 'blaze-ui/icons/24'
import { DesktopBadge } from '../DesktopBadge/DesktopBadge'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuApprovalsItem = ({ workspace, onPress }: Props) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const to = generatePath(APPROVALS_PATH, { workspaceId: workspace.id })

  if (isSystemRedesignEnabled) {
    return <NavMenuItem icon={Approvals} activeIcon={Approvals} to={to} onPress={onPress} label="Approvals" />
  }

  return (
    <NavMenuItem icon={Approvals} activeIcon={Approvals} to={to} onPress={onPress} label="Approvals">
      <DesktopBadge />
    </NavMenuItem>
  )
}

export { NavMenuApprovalsItem }
